import { Link as RouterLink } from 'react-router-dom'

import { Button, Dialog, Flex } from '@buffer-mono/popcorn'

import { channel } from '~publish/legacy/routes'

import { ConfirmationDialog } from '../ConfirmationDialog'

import styles from './PostItemsFooter.module.css'

import type { JSX } from 'react'

export const PostItemsFooter = ({
  channelId,
  channelName,
  successItemCount,
  validItemCount,
  selectedSaveAction,
  isCreatingPosts,
  canStartPostCreation,
  isPostCreationComplete,
  onCreatePosts,
  onDialogClose,
}: {
  channelId: string
  channelName: string
  successItemCount: number
  validItemCount: number
  selectedSaveAction: 'post' | 'draft'
  isCreatingPosts: boolean
  canStartPostCreation: boolean
  isPostCreationComplete: boolean
  onCreatePosts: (type: 'post' | 'draft') => void
  onDialogClose: (closeAction: 'success' | 'cancel') => void
}): JSX.Element => {
  return (
    <Dialog.Footer className={styles.footer}>
      {canStartPostCreation || isCreatingPosts ? (
        <Flex gap="sm">
          {!isCreatingPosts && (
            <ConfirmationDialog
              count={validItemCount}
              channelName={channelName}
              postType="draft"
              onConfirm={() => onCreatePosts('draft')}
            >
              <Button size="large" variant="secondary">
                Save as Drafts
              </Button>
            </ConfirmationDialog>
          )}
          <ConfirmationDialog
            count={validItemCount}
            channelName={channelName}
            postType="post"
            onConfirm={() => onCreatePosts('post')}
          >
            <Button size="large" loading={isCreatingPosts}>
              {isCreatingPosts ? 'Processing...' : 'Schedule Posts'}
            </Button>
          </ConfirmationDialog>
        </Flex>
      ) : isPostCreationComplete ? (
        <Flex gap="sm">
          <Dialog.Close onClick={() => onDialogClose('success')}>
            <Button
              variant={successItemCount > 0 ? 'tertiary' : 'secondary'}
              size="large"
            >
              Done
            </Button>
          </Dialog.Close>
          {successItemCount > 0 && (
            <Button
              as={RouterLink}
              to={channel.getRoute(channelId, {
                tab: selectedSaveAction === 'draft' ? 'drafts' : 'queue',
              })}
              onClick={() => onDialogClose('success')}
              variant="secondary"
              size="large"
            >
              {selectedSaveAction === 'draft' ? 'View Drafts' : 'View Posts'}
            </Button>
          )}
        </Flex>
      ) : (
        <Dialog.Close onClick={() => onDialogClose('cancel')}>
          <Button variant="secondary" size="large">
            Done
          </Button>
        </Dialog.Close>
      )}
    </Dialog.Footer>
  )
}
